import { LocationDto } from "./location-dto";

export class CustomerDTO {
    refNo: string;
    customerEmail: String;
    fromLocationCode: number;
    customerMobile: String;
    customerName: String;
    stateCode: number;
    location: LocationDto = new LocationDto()
}
